import Tile from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import tile from 'ol/source/Tile'

export class GoogleMapsSource extends XYZ {
    constructor() {
        super({
            url: 'https://mt{0-3}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
            attributions: [
                '&copy; <a href="https://www.google.com/maps">Google Maps</a>',
            ],
            crossOrigin: 'anonymous',
            cacheSize: 64,
            maxZoom: 20,
            minZoom: 0,
        });
    }
}

export class MapSatelliteLayer extends Tile<tile> {
    constructor(source = new GoogleMapsSource()) {
        super({
            preload: Infinity,
            visible: true,
            source,
        });
    }
}

export const createGoogleMapsSource = () => new GoogleMapsSource();

export const createMapSatelliteLayer = () => new MapSatelliteLayer(createGoogleMapsSource());
